import React from "react";
import classNames from "classnames";
import { IconProps } from "../type";

export function Upload2Icon({
  className,
  style,
  selected,
  color = "#1B1D20",
  ...props
}: IconProps & { selected?: boolean; color?: React.CSSProperties["color"] }) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      className={classNames(["h-full w-full", className])}
      style={style}
      viewBox='0 0 24 25'
      fill='none'
      {...props}
    >
      <path
        d='M21 15.4312L21 19.4312C21 19.9616 20.7893 20.4703 20.4142 20.8454C20.0391 21.2204 19.5304 21.4312 19 21.4312L5 21.4312C4.46957 21.4312 3.96086 21.2204 3.58579 20.8454C3.21071 20.4703 3 19.9616 3 19.4312L3 15.4312'
        stroke={selected ? "#8B33FF" : color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M17 8.43115L12 3.43115L7 8.43115'
        stroke={selected ? "#8B33FF" : color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M12 15.4312L12 3.43115'
        stroke={selected ? "#8B33FF" : color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
